import styled, { css } from "styled-components";

import {
  FormControl as MuiFormControl,
  InputLabel as MuiInputLabel,
  Select as MuiSelect,
  Radio,
  SelectProps,
} from "@mui/material";

import { Delete } from "@mui/icons-material";
import { HTMLAttributes } from "react";

export const Container = styled.div`
  width: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 25px;
`;

export const Row = styled.div`
  display: flex;
  gap: 40px;
  align-items: flex-start;
  justify-content: start;
`;

/** Coluna para empilhar um campo e a sua mensagem de validação abaixo dele. */
export const FieldWithHint = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ValidationError = styled.span`
  color: #d32f2f;
  font-size: 0.75rem;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #191c1a;
`;

const FormControl = styled(MuiFormControl)`
  width: 300px;
`;

const InputLabel = styled(MuiInputLabel)`
  color: rgb(118, 118, 118);

  & .Mui-focused {
    color: blue;
  }
`;

const Select = styled(MuiSelect)`
  height: 55.3px;
  margin-bottom: 2.7px;

  & .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgb(121, 121, 121);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }
`;

export const ButtonDelete = styled(Delete)`
  cursor: pointer;
  width: 30px;
`;

interface ISelectFormProps extends Omit<SelectProps, "ref"> {
  label: string;
}

export const SelectForm = ({
  label,
  children,
  ...selectProps
}: ISelectFormProps) => {
  return (
    <FormControl>
      <InputLabel>{label}</InputLabel>
      <Select {...selectProps}>{children}</Select>
    </FormControl>
  );
};

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  border: solid 1px #0000003B;
`;

interface IRadioCardProps extends HTMLAttributes<HTMLDivElement> {
  selected: boolean;
  label: string;
}

export const RadioCard = ({ selected, label, ...rest }: IRadioCardProps) => {
  return (
    <Card style={{ borderColor: selected ? "#3024E1" : "#0000003B", cursor: "pointer" }} {...rest}>
      <Radio checked={selected} color="primary" />
      <span style={{ color: selected ? "#3024E1" : "#191C1A", fontWeight: selected ? "600" : "400", fontSize: "14px" }}>{label}</span>
    </Card>
  )
}

export const MultiWrapper = styled.div`
  width: 100%;
  border: solid 1px #e8e8e8;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
`;

export const MultiButton = styled.button<{ variant: "active" | "inactive" }>`
  padding: 4px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  background-color: ${({ variant }) =>
    variant === "active" ? "#E9E6FB" : "transparent"};
  color: ${({ variant }) => (variant === "active" ? "#2F2CEE" : "#1A1A1A")};
  transition: background-color 0.2s;

  ${({ variant }) =>
    variant === "inactive" &&
    css`
      &:hover {
        background-color: #f5f5f5;
      }
    `}

  &:disabled {
    cursor: initial;
    opacity: 0.2;
    &:hover {
      background-color: initial;
    }
  }
`;